import React from 'react';
import { HiddenField } from 'candidate_profile_redesign/shared/form/Fields';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';

export const TrackLastPage = ({ isLastPage }: { isLastPage: boolean }) => {
  const { setValue } = useFormContext();

  React.useEffect(() => {
    setValue('isLastPage', isLastPage);
  }, [isLastPage, setValue]);

  return <HiddenField name="isLastPage" />;
};
